/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { RootStoreType } from "./index"


/**
 * StoreDriverPushTokenDtoBase
 * auto generated base class for the model StoreDriverPushTokenDtoModel.
 */
export const StoreDriverPushTokenDtoModelBase = ModelBase
  .named('StoreDriverPushTokenDto')
  .props({
    __typename: types.optional(types.literal("StoreDriverPushTokenDto"), "StoreDriverPushTokenDto"),
    userUuid: types.union(types.undefined, types.string),
    token: types.union(types.undefined, types.string),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class StoreDriverPushTokenDtoModelSelector extends QueryBuilder {
  get userUuid() { return this.__attr(`userUuid`) }
  get token() { return this.__attr(`token`) }
}
export function selectFromStoreDriverPushTokenDto() {
  return new StoreDriverPushTokenDtoModelSelector()
}

export const storeDriverPushTokenDtoModelPrimitives = selectFromStoreDriverPushTokenDto().userUuid.token
